<template>
    <div class="row">
        <div class="col-12">
            <div class="card card-primary " v-if="notesList.length || showNotesList">
                <div class="card-header">
                    <span class="fa fa-sticky-note"></span> {{trans('projects.cards.header.project_notes')}}
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <br>
                            <div class="direct-chat direct-chat-primary">
                                <!--<li class="list-group-item" >-->
                                <div v-for="item in notesListSorted"
                                     :class="'direct-chat-msg' + (user.id === item.user_id ? ' right' : '')">
                                    <div class="direct-chat-info clearfix">
                                            <span :class="'direct-chat-name' + (user.id === item.user_id ? ' pull-right' : ' pull-left')"><project-type-label
                                                    :item_type="item.project_note_type">
                                            </project-type-label> | {{ item.user.full_name }}</span>
                                        <span :class="'direct-chat-timestamp'  + (user.id === item.user_id ? ' pull-left' : ' pull-right')">{{renderDate(item.updated_at)}}</span>
                                    </div>
                                    <!-- /.direct-chat-info -->
                                    <img class="direct-chat-img" :src="item.user.photo_url"
                                         :alt="item.user.full_name"><!-- /.direct-chat-img -->
                                    <div class="direct-chat-text">
                                        <froalaView v-model="item.note"></froalaView>
                                        <!--{{item.note}}-->
                                    </div>
                                    <div class="clearfix">
                                        <button v-if="item.user_id === user.id"
                                                class="btn btn-sm pull-right btn-outline-danger btn-remove"
                                                @click="deleteItem(item)">Remove
                                        </button>
                                    </div>
                                    <!-- /.direct-chat-text -->
                                </div>

                                <!--<div class="heading">-->
                                <!--<project-type-label :item_type="item.project_note_type"></project-type-label>-->
                                <!--<strong>{{ item.user.full_name }}</strong>-->
                                <!--| {{ renderDate(item.updated_at) }}-->
                                <!--</div>-->
                                <!--<div class="body">{{item.note}}</div>-->
                                <!--<strong class="delete" @click="deleteItem(item)">X</strong>-->
                                <!--</li>-->
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <hr>
                            <div v-if="errorMessages.length > 0" class="alert alert-danger alert-dismissable">
                                <button type="button" class="close" data-dismiss="alert"
                                        aria-hidden="true">&times;
                                </button>
                                <strong>Error:</strong> <span v-for="errorMessage in errorMessages">{{ errorMessage }}
                                &nbsp;</span>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div v-if="edit" class="form-row form form-horizontal">
                                <div class="form-group col-sm-12">
                                    <froala
                                            name="note"
                                            ref="editor"
                                            tag="textarea" v-model="editItem.note">
                                    </froala>

                                    <!--<textarea v-model="editItem.note" class="form-control"-->
                                    <!--name="note" id="note" rows="3"-->
                                    <!--</div>-->
                                </div>
                                <div class="form-group col-md-6 offset-md-6">
                                    <div class="row">
                                        <div class="col-sm-3 pull-right">
                                            <button class="btn btn-info" @click="edit = false">Cancel</button>
                                        </div>
                                        <div class="col-sm-3 pull-right">
                                            <button class="btn btn-primary" @click="editNotesListItem">Edit</button>
                                        </div>
                                        <div class="col-sm-6 pull-right">
                                            <select v-model="newItem.project_note_type_id" name="project_note_type_id"
                                                    class="form-control">
                                                <option v-for="projectNoteType in projectNoteTypes"
                                                        :key="projectNoteType.id" :value="projectNoteType.id">
                                                    {{projectNoteType.name}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="form-row form form-horizontal">

                                <div class="form-group col-sm-12">
                                    <froala
                                            name="note"
                                            ref="editor"
                                            tag="textarea" v-model="newItem.note">
                                    </froala>
                                    <!--<textarea v-model="newItem.note" class="form-control"-->
                                    <!--name="note" id="note" rows="3"-->
                                    <!--placeholder=""></textarea>-->
                                </div>
                                <div class="form-group col-md-6 offset-md-6">
                                    <div class="row">
                                        <div class="col-sm-6 offset-2 pull-right">
                                            <select v-model="newItem.project_note_type_id" name="project_note_type_id"
                                                    class="form-control">
                                                <option v-for="projectNoteType in projectNoteTypes"
                                                        :key="projectNoteType.id" :value="projectNoteType.id">
                                                    {{projectNoteType.name}}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="col-sm-4 pull-right">
                                            <button class="btn btn-primary btn-block" @click="createNotesListItem">
                                                Create
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="card card-no-bg">
                <button class="btn btn-primary" @click="makeShowNotesList">
                    {{trans('projects.cards.header.project_notes')}} <span v-if="notesList.length > 0"
                                                                           class="badge badge-light">{{notesList.length}}</span>
                </button>
            </div>
        </div>
    </div>
</template>
<style lang="scss">
    .direct-chat {
        .btn-remove {
            margin-top: 2px;
            margin-right: 49px;
        }
    }
</style>
<script>


    let moment = require('moment');

    export default {
        props: {
            project: Object,
            projectNoteTypes: Array,
            user: Object,
        },
        data: function () {
            return {
                edit: false,
                notesList: [],
                newItem: {},
                editItem: {},
                showNotesList: false,
                errorMessages: []
            };
        },
        computed: {
            notesListSorted: function () {
                return _.sortBy(this.notesList, function (item) {
                    return moment(item.updated_at, 'YYYY-MM-DD HH:mm:ss');
                });
            }
        },
        created: function () {
            this.newItemToBase();
            this.fetchNotesList();
        },
        methods: {
            trans: function (path) {
                return Lang.trans(path);
            },
            renderProjectNoteTypeColor: function (item) {
                if (item.project_note_type) {
                    return item.project_note_type.color;
                }
                return '';
            },
            renderProjectNoteTypeName: function (item) {
                if (item.project_note_type) {
                    return item.project_note_type.name;
                }
                return '';
            },
            getProjectNoteTypeLabel: function (item) {
                if (item.project_note_type) {
                    return '<span style="background-color: ' + item.project_note_type.color + '">' + item.project_note_type.name + '</span> | '
                }
                return '';
            },
            renderDate: function (date) {
                if (moment(date).isValid()) {
                    return moment(date, "YYYY-MM-DD HH:mm:ss").format("DD.MM.YYYY");
                }
                return '';
            },
            startEdit: function (item) {
                this.edit = true;
                this.editItem = Object.assign({}, item);
            },
            deleteItem: function (item) {
                // var resource = this.$resource('/visi/api/project-notes{/id}');
                let vm = this;
                var r = confirm("Are you sure to delete this note?");
                if (r == true) {
                    axios.delete(laroute.route('json.project_notes', {project: this.project.id, project_note: item.id}))
                        .then(response => {
                            if (response.data.success) {
                                vm.fetchNotesList();
                            } else {
                                vm.throwError('Error :(');
                            }
                        })
                        .catch(error => {
                            console.log(error);
                            vm.throwError(_.values(error.response.data.errors));
                        });
                }

                // resource
                //     .delete({id: item.id})
                //     .then(function (response) {
                //         response = response.body;
                //         if (response.success) {
                //             this.fetchNotesList();
                //         } else {
                //             this.throwError(response.error);
                //         }
                //     });
            },
            newItemToBase: function () {
                this.newItem = Object.assign({}, this.newItem,
                    {
                        project_id: this.project.id,
                        note: ""
                    });

            },
            throwError: function (error) {
                if (Array.isArray(error)) {
                    this.errorMessages = error;
                } else {
                    this.errorMessages = [error];
                }
            },
            disableErrors: function () {
                this.errorMessages = [];
            },
            createNotesListItem: function () {
                // var resource = this.$resource('/visi/api/project-notes{/id}');
                let vm = this;
                this.disableErrors();

                axios.post(laroute.route('project.project_notes.create', {
                    project: this.project.id
                }), this.newItem)
                    .then(response => {
                        if (response.data.success) {
                            vm.fetchNotesList();
                            vm.newItemToBase();
                        } else {
                            vm.throwError('Error :(');
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        vm.throwError(_.values(error.response.data.errors));

                    });

                // resource.save(this.newItem).then(function (response) {
                //     response = response.body;
                //     if (response.success) {
                //         vm.fetchNotesList();
                //         vm.newItemToBase();
                //     } else {
                //         this.throwError(response.error);
                //     }
                // });
            },
            editNotesListItem: function () {
                // var resource = this.$resource('/visi/api/project-notes{/id}');
                let vm = this;
                this.disableErrors();

                axios.post(laroute.route('json.project_notes.update', {project_note: this.editItem.id}),
                    this.editItem)
                    .then(response => {
                        if (response.data.success) {
                            vm.edit = false;
                            vm.fetchNotesList();
                        } else {
                            vm.throwError('Error :(');
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        vm.throwError(_.values(error.response.data.errors));
                    });


                // resource.update({id: this.editItem.id}, this.editItem).then(function (response) {
                //     response = response.body;
                //     if (response.success) {
                //         vm.edit = false;
                //         vm.fetchNotesList();
                //     } else {
                //         this.throwError(response.error);
                //     }
                // });
            },
            makeShowNotesList: function () {
                this.showNotesList = true;
            },
            fetchNotesList: function () {
                let vm = this;

                axios.get(laroute.route('project.project_notes', {project: this.project.id}))
                    .then(response => {
                        vm.notesList = response.data;
                    })
                    .catch(error => {
                        console.log(error);
                        vm.throwError(_.values(error.response.data.errors));
                    });
                // var resource = this.$resource('/visi/api/project-notes{/id}');

                // resource.get({project_id: "{{$project->id}}"}).then(function (response) {
                //     vm.notesList = response.body;
                // });


            }

        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/projects/ProjectNotes.vue